<template>
  <div>
  <div v-if="transactions.length > 0">
    <Transactions :items="transactions"/>
  </div>
  <div v-else> No Transaction Have Been Recorded Yet </div>
  </div>

</template>

<script>
import { getTransactions } from '@/services/transaction'
import Transactions from './Transactions'

export default {
  name: 'TransactionsAdminPage',
  components: {
    Transactions
  },

  data () {
    return {
      transactions: []
    }
  },

  mounted () {
    this.loadTransactions()
  },

  methods: {
    loadTransactions () {
      getTransactions()
        .then(res => {
          this.transactions = res.data
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/transactions/TransactionsAdminPage.vue